import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import SocialMedia from './SocialMedia';
import { SectionNames } from './PortalState/SectionDataMetaData';

const SocialMediaPage = ({ styles, socialMediaList, imageLoading, imageType, uploadLogoFile, handleChange, onDeleteEntry, onAddEntry, errors }) => {
    const addANewEntry = () => {
        onAddEntry(SectionNames.socialMediaTab);
    }

    return (
        <>
            <Grid item container xs={12} mt={3}>
                <Typography className={styles.textInputLabel}>
                    Social Media
                </Typography>
            </Grid>
            <Grid
                mt={1}
                container
                direction="row"
                justifyContent={"space-between"}
                item
                xs={12}
                md={12}
                mb={2}
                sx={{ padding: "1.5rem 2rem" }}
            >
                {socialMediaList.length === 0 ? (
                    <Typography sx={{ color: "#888", fontSize: "14px", fontFamily: "GilroyMedium", textAlign: "center", width: "100%", py: 2 }}>
                        No social media links added yet. Click "Add Entry" to get started.
                    </Typography>
                ) : socialMediaList.map((x, i) => {
                    return (
                        <SocialMedia
                            key={i}
                            index={i}
                            data={x}
                            imageLoading={imageLoading}
                            imageType={imageType}
                            uploadLogoFile={uploadLogoFile}
                            handleChange={handleChange}
                            onDeleteEntry={onDeleteEntry}
                            errors={errors}
                            isLast={i === socialMediaList.length - 1}
                        />
                    );
                })}
            </Grid>
            <Grid container item xs={12} justifyContent={"flex-end"} mt={-1}>
                <Button
                    type="button"
                    disabled={false}
                    className={styles.addEntry}
                    onClick={addANewEntry}
                >
                    Add Entry
                </Button>
            </Grid>
        </>
    )
}

export default React.memo(SocialMediaPage);
